import { Injectable } from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthenticationService } from '../auth/services/authentication.service';
import { TidService } from '../auth/services/tid.service';

@Injectable({
  providedIn: 'root',
})
export class SwitchAuthGuard implements CanActivate {
  constructor(
    private activatedRoute: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private tidService: TidService
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    const userName = route.params.username;
    const accountName = route.params.accountname;
    const authToken = route.params.authToken;
    if (authToken) {
      return this.authenticationService
        .getUserInfo(userName, accountName, authToken)
        .pipe(
          map(([data, token]) => {
            this.tidService.loginSuccess(data.user, token);
            return true;
          })
        );
    }
  }
}
